import { BaseQueryApi } from '@reduxjs/toolkit/query'

import { displayRulesApi } from '@redux/api'

type Props = {
  ids: number[] | undefined
  api: BaseQueryApi
}

export const fetchDisplayRulesByIds = async (props: Props) => {
  const { api, ids } = props

  const contextMenusPromises =
    ids?.map(id => {
      return api.dispatch(displayRulesApi.endpoints.fetchDisplayRuleById.initiate({ id })).unwrap()
    }) || []

  const entities = await Promise.all(contextMenusPromises)

  return new Map(entities.map((entity, index) => [ids?.[index], entity]))
}
